var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn current-position__button",on:{"click":function($event){$event.preventDefault();return _vm.setCurrentPosition.apply(null, arguments)}}},[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"size":"16","indeterminate":"","color":"grey","width":"2"}}):_c('v-icon',{attrs:{"size":"18"}},[_vm._v(" mdi-crosshairs-gps ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }